//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

import angular from 'angular';

import template from './catalog-menu.html';

angular.module('curalate').component('catalogMenu', {
  template,
});
